export const maxLength = (value: number) => ({
  value,
  message: `Must be less than ${value} characters`,
})
